module.exports = __webpack_public_path__ + "img/INDUSTRIA_01_prew.1eae5c75.jpg";